import styled from "styled-components";

import Typography from "../Typography";
import Button from "../Button";
import theme from "../../theme";
interface ButtonTabItem {
  title: string;
  count?: number;
}

interface ButtonTabProps {
  items: ButtonTabItem[];
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  ghost?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px;
  border: 1px solid #f1effb;
  border-radius: 12px;
`;

const GhostContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 50px;
`;

export const ButtonTab = ({
  items,
  activeIndex,
  setActiveIndex,
  ghost,
}: ButtonTabProps) => {
  if (ghost) {
    return (
      <GhostContainer>
        {items.map((item, index) => (
          <div
            style={{
              color: activeIndex === index ? "#1A50B1" : "#9E9E9E",
              backgroundColor: activeIndex === index ? "#f9f9fd" : "#f9f9fd",
              borderRadius: 4,
              display: "flex",
              alignItems: "center",
              height: 38,
              cursor: "pointer",
            }}
            key={item.title}
            onClick={() => {
              setActiveIndex(index);
            }}
          >
            {/**@ts-ignore */}
            <Typography
              fontFamily="urbanist"
              size="h4"
              style={{
                color: activeIndex === index ? "#1A50B1" : "#7E7E7E",
              }}
            >
              {item.title}
            </Typography>
            {item.count !== 0 && item.count != null && (
              <Typography
                size="h4"
                style={{ color: activeIndex === index ? "#1A50B1" : "#7E7E7E" }}
              >
                ({item.count})
              </Typography>
            )}
          </div>
        ))}
      </GhostContainer>
    );
  }
  return (
    <Container>
      {items.map((item, index) => (
        <Button
          style={{
            color: activeIndex === index ? "white" : "black",
            backgroundColor: activeIndex === index ? "#F1EFFB" : "white",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            gap: 20,
            height: 38,
          }}
          key={item.title}
          onClick={() => {
            setActiveIndex(index);
          }}
        >
          {/**@ts-ignore */}
          <Typography
            fontFamily="urbanist"
            style={{
              color: activeIndex === index ? "#725ED4" : "#7E7E7E",
              fontSize: "14px",
            }}
          >
            {item.title}
          </Typography>
          {item.count && (
            <Typography
              //@ts-ignore
              style={{ color: activeIndex === index && "white" }}
            >
              ({item.count})
            </Typography>
          )}
        </Button>
      ))}
    </Container>
  );
};
